import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import type {
  NumbersSectionItemFields,
  NumbersSectionProps,
} from '@/types/components/NumbersSection';
import type { ScItem } from '@/types/sitecore';
import utils from '@/utils';

interface NormalizedItem extends ScItem<NumbersSectionItemFields> {
  fields: NumbersSectionItemFields;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NumbersSection',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const sectionEl = ref<HTMLElement | null>(null);
const isInView = ref(false);
const animationCycle = ref(0);
let visibilityObserver: IntersectionObserver | null = null;
const fields = computed(() => props.fields);
const rendering = computed(() => props.rendering);

const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});
const tone = computed(() => fields.value?.tone?.value || 'gold');
const rootClass = computed(() => {
  const result = utils.overall.baseComClass(props.fields, 'c-numbers-section');
  result.push(`c-numbers-section--${tone.value}`);
  return result;
});
const rawItems = computed<ScItem<NumbersSectionItemFields>[]>(() => {
  const statItems = utils.sc.getFieldObj(fields.value, 'items');
  return Array.isArray(statItems) ? statItems : [];
});

const items = computed<NormalizedItem[]>(() =>
  rawItems.value.filter((item): item is NormalizedItem => Boolean(item.fields))
);

onMounted(() => {
  if (!sectionEl.value || !window.IntersectionObserver) {
    isInView.value = true;
    animationCycle.value += 1;
    return;
  }

  visibilityObserver = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        animationCycle.value += 1;
        isInView.value = true;
      } else {
        isInView.value = false;
      }
    },
    { threshold: 0.1 }
  );
  visibilityObserver.observe(sectionEl.value);
});

onBeforeUnmount(() => {
  visibilityObserver?.disconnect();
});

return (_ctx: any,_cache: any) => {
  const _component_FlippedNumber = _resolveComponent("FlippedNumber")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value && items.value.length)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: rendering.value?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              ref_key: "sectionEl",
              ref: sectionEl,
              class: "c-numbers-section__inner"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: item.id,
                  class: "c-numbers-section__item"
                }, [
                  (isInView.value && item.fields.number?.value)
                    ? (_openBlock(), _createBlock(_component_FlippedNumber, {
                        key: `${item.id}-${animationCycle.value}`,
                        class: "c-numbers-section__number",
                        number: item.fields.number.value,
                        speed: 1200
                      }, null, 8, ["number"]))
                    : _createCommentVNode("", true),
                  (item.fields.description?.value)
                    ? (_openBlock(), _createBlock(_unref(RichText), {
                        key: 1,
                        class: "c-numbers-section__description",
                        field: item.fields.description
                      }, null, 8, ["field"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 512)
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})